import { createAction } from "redux-actions";

export const setConsultaDinamica = createAction(
  'SET_CONSULTAS_DINAMICAS', (consultas) => consultas
);

export const setActiveConsulta = createAction(
  'SET_ACTIVE_CONSULTA', (indice) => indice
);
